import { useOutletContext, useNavigate } from "react-router-dom";

import PageAbstract from "components/PageAbstract";
import {
  Box,
  Button,
  FormControl,
  Menu,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import i18n from "../../i18";
import _request from "../../actions/_request";
import _helper from "../../actions/_helper";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ImageError from "../../components/ImageError";
import moment from "moment-timezone";
import React from "react";

import "./style.css";
import AvatarIcon from "../../components/AvatarIcon";
import IconsAccounts from "../../components/IconsAccounts";
import { MoreHorizontalIcon } from "../../components/AdaptiveIcon";

import { ReactComponent as EmptyDraft } from "../../images/No draft collection.svg";

const safeJsonParse = (str, fallback) => {
  try {
    const v = JSON.parse(str);
    return v ?? fallback;
  } catch {
    return fallback;
  }
};

class DraftsPage extends PageAbstract {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      items: [],
      posts: [],
      getDraftAccounts: [],
      draftCollections: [],
      showBlock: true,
      charCount: 0,
      anchorEl: null,
      openedMenu: null,
      postsAccountData: {},
      socialType: "all",
      sortOrder: "newest",
      anchorPostDraft: null,
      loading: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    this.setState({ loading: true });
    try {
      const resp = await _request.draftCollections.getAll();
      const respPost = await _request.posts.getAll(
        [{ field: "updated_at", direction: "DESC" }],
        [{ field: "status", operator: "=", value: "draft" }],
      );
      const rawPosts = respPost?.data?.items || [];
      const posts = rawPosts.map((p) => ({
        ...p,
        type_data: typeof p.type_data === "string" ? safeJsonParse(p.type_data, {}) : p.type_data || {},
        tags: typeof p.tags === "string" ? safeJsonParse(p.tags, []) : p.tags || [],
      }));
      this.setState({
        draftCollections: resp?.data?.items || [],
        posts,
        loading: false,
      });
    } catch (error) {
      console.error("Error loading data:", error);
      this.setState({ loading: false });
    }
  }

  async handlePostClick(postId) {
    try {
      const fetchedData = await _request.posts.getDraftAccounts(postId);
      this.setState((prevState) => ({
        postsAccountData: {
          ...prevState.postsAccountData,
          [postId]: fetchedData.data,
        },
      }));
    } catch (error) {
      console.error("Error fetching draft accounts:", error);
    }
  }

  addUpdateDraft(id) {
    const title = this.newDraftName.value;

    const obj = {
      title,
    };
    if (id) obj.id = id;

    _request.draftCollections.loading(async () => {
      await _request.draftCollections.addUpdate(obj);
      this.refresh();
    });
  }
  deleteDraft({ id }) {
    _helper.confirm(
      "dialog.groupRemove",
      this.deleteDraftConfirmed.bind(this, id)
    );
  }

  deleteDraftConfirmed(id) {
    _request.draftCollections.loading(async () => {
      await _request.draftCollections.delete(id);
      this.refresh();
    });
  }

  handleInputChange(event) {
    this.setState({ charCount: event.target.value.length });
  }
  handleClose() {
    this.setState({ anchorEl: null });
  }

  getEditFolderContent(tProps, onClick, hideCb) {
    const { charCount } = this.state;

    return (
      <Box className="flex column gap16">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} />
        <Typography component="span" className="font w700 f16">
          {i18n.t("draftsPage.title")}
        </Typography>
        <Box
          className="flex column gap16"
          sx={{
            position: "relative",
            backgroundColor: "var( --background-preview)",
            color: "var(--text-color)",
          }}>
          {this.insertGlobalInput(
            {
              inputRef: (el) => (this.newDraftName = el),
              autoFocus: true,
              size: "small",
              sx: { minWidth: "400px" },
              inputProps: {
                maxLength: 60,
                style: {
                  width: "81%",
                  backgroundColor: "var( --background-preview)",
                  color: "var(--text-color)",
                },
              },
              ...tProps,
              onChange: this.handleInputChange,
            },
            {
              onEnter: () => {
                hideCb();
                onClick();
              },
            }
          )}
          <Typography
            component="span"
            className="font f12"
            sx={{
              position: "absolute",
              right: "8px",
              top: "8px",
              color: "gray",
            }}>
            {charCount}/60
          </Typography>
        </Box>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider", marginTop: "20px" }}
        />
      </Box>
    );
  }

  openEditFolderDialog(label, onClick, tProps = {}) {
    this.openEditDialog("pageDialogProps", {
      title: "draftsPage.drafts",
      label,
      onClick,
      text: this.getEditFolderContent.bind(
        this,
        tProps,
        onClick,
        this.changeState.bind(this, "pageDialogProps", null)
      ),
    });
  }

  addDraftShow() {
    this.openEditFolderDialog("create", this.addUpdateDraft.bind(this), {}, []);
  }

  editDraftShow(id) {
    const info = this.state.draftCollections.find((it) => it.id === id);
    const defaultValue = info?.title || "";
    this.openEditFolderDialog(
      "save",
      this.addUpdateDraft.bind(this, info?.id),
      { defaultValue }
    );
  }

  handleMenuOpen = (event, id) => {
    this.setState({
      anchorEl: event.currentTarget,
      menuItemId: id,
    });
  };
  insertMenuItems() {
    const { anchorEl, menuItemId } = this.state;
    const open = Boolean(anchorEl);

    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={this.handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        <MenuItem
          onClick={() => {
            this.editDraftShow(menuItemId);
            this.handleClose();
          }}>
          {i18n.t("draftsPage.edit")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            this.deleteDraft({ id: menuItemId });
            this.handleClose();
          }}>
          {i18n.t("draftsPage.delete")}
        </MenuItem>
      </Menu>
    );
  }

  insertGroup(key, info) {
    const { posts, editMode } = this.state;
    const { id, title } = info;
    const selectedPosts = posts.filter(
      (post) => post.draft_collection_id === id && post.status === "draft"
    );
    const firstFileId = selectedPosts[0]?.type_data?.files?.[0];
    const imageSrc = firstFileId ? _request.files.formLink(firstFileId) : null;
    const count = selectedPosts.length;

    return (
      <Box
        key={key}
        className="flex gap-12 justify-center hover-parent"
        sx={{
          backgroundColor: "#212832",
          width: "243px",
          height: "200px",
          borderRadius: "5px",
          position: "relative",
        }}>
        <Box className="grid place-content-center cursor-pointer">
          <Box
            onClick={() => {
              this.setState({ selectedItemId: id, showBlock: false });
            }}>
            <ImageError
              src={imageSrc}
              className="img"
              width="213px"
              height="121px"
              style={{ marginTop: "10px" }}
            />
            <Typography
              component="span"
              variant="body1"
              sx={{
                color: "white",
                marginTop: "10px",
                textTransform: "capitalize",
              }}>
              {title}
            </Typography>
            <Box className="flex items-center mt-2">
              <Box className="cntIcon mr-1" />
              <Typography
                component="span"
                sx={{
                  color: "rgba(255,255,255,0.54)",
                  fontWeight: 600,
                  fontSize: "14px",
                }}>
                {count} {i18n.t("draftsPage.draftsCount", { count })}
              </Typography>
            </Box>
          </Box>
          <Box
            className="more-icon"
            sx={{ display: editMode ? "block" : "none" }}
            onClick={(e) => this.handleMenuOpen(e, id)}>
            <MoreHorizontalIcon
              style={{
                width: "30px",
                height: "30px",
                color: "white",
              }}
            />
          </Box>
          {this.insertMenuItems()}
        </Box>
      </Box>
    );
  }

  retrieveItemsDrafts(posts, draftCollections) {
    const selectedCollection = draftCollections.find(
      (collection) => collection.id === this.state.selectedItemId
    );

    if (!selectedCollection) {
      return null;
    }

    return (
      <Box className="flex column centerV">
        {this.renderPostsForCollection(selectedCollection, posts)}
      </Box>
    );
  }

  deleteDraftPost(id) {
    _request.posts.loading(async () => {
      await _request.posts.delete(id);
      this.refresh();
    });
  }

  renderPostsForCollection(collection, posts) {
    const postsForCollection = posts.filter(
      (post) => post.draft_collection_id === collection.id
    );

    return postsForCollection.map((post, i) => (
      <Box key={i} className="flex justify-center w-full m-1 p-1">
        {this.renderPostContent(post)}
        <img
          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
          onLoad={() => this.handlePostClick(post.id)}
          alt="trigger"
          style={{ display: "none" }}
        />
      </Box>
    ));
  }

  handleMenuDraft = (event, id) => {
    this.setState({
      anchorPostDraft: event.currentTarget,
      menuPostId: id,
    });
  };

  handeClosePostDraft = () => {
    this.setState({ anchorPostDraft: null });
  };

  insertMenuDraftItems() {
    const { anchorPostDraft, menuPostId } = this.state;
    const open = Boolean(anchorPostDraft);

    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorPostDraft}
        open={open}
        onClose={this.handeClosePostDraft}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        <MenuItem
          onClick={() => {
            this.editDraftPost(menuPostId);
            this.handeClosePostDraft();
          }}>
          {i18n.t("draftsPage.edit")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            this.deleteDraftPost({ id: menuPostId });
            this.handeClosePostDraft();
          }}>
          {i18n.t("draftsPage.delete")}
        </MenuItem>
      </Menu>
    );
  }

  editDraftPost = (draftId) => {
    const { posts, loading } = this.state;

    // If still loading, wait a bit and retry
    if (loading) {
      setTimeout(() => this.editDraftPost(draftId), 1000);
      return;
    }

    if (!posts || !Array.isArray(posts) || posts.length === 0) {
      console.error("Posts array is not available or empty:", posts);
      // Try to reload data if posts is empty
      if (!posts || posts.length === 0) {
        this.loadData().then(() => {
          // Retry after loading
          const { posts: reloadedPosts } = this.state;
          if (reloadedPosts && Array.isArray(reloadedPosts)) {
            const draftToEdit = reloadedPosts.find(
              (draft) => draft && draft.id === draftId
            );
            if (draftToEdit) {
              this.props.navigate("/app/post", {
                state: {
                  editDraft: true,
                  draftData: draftToEdit,
                },
              });
            }
          }
        });
      }
      return;
    }

    // Double check each post has required properties
    const draftToEdit = posts.find((draft) => {
      return draft && typeof draft === "object" && draft.id === draftId;
    });

    if (draftToEdit) {
      this.props.navigate("/app/post", {
        state: {
          editDraft: true,
          draftData: draftToEdit,
        },
      });
    } else {
      console.error(
        "Draft not found with ID:",
        draftId,
        "Available posts:",
        posts
      );
    }
  };

  renderPostContent(post) {
    const { type_data, schedule_date } = post;
    const { postsAccountData } = this.state;
    const accountData = postsAccountData[post.id];

    if (!accountData) {
      return <div>{i18n.t("draftsPage.loading")}</div>;
    }

    const hasAccount = accountData.length > 0;
    const avatar = hasAccount ? accountData[0].avatar : null;
    const username = hasAccount ? accountData[0].username : "Unknown";
    const social_type = hasAccount ? accountData[0].social_type : null;
    const files = Array.isArray(type_data?.files) ? type_data.files : [];
    const countFiles = Math.max(files.length - 1, 0);
    const previewFileId = files[0];

    return (
      <Box
        className="flex column gap-12 w-2/3 p-4"
        sx={{ backgroundColor: "var(--background-menu)" }}>
        <Box className="flex justify-between items-center relative">
          <Box className="flex column gap-4 w-9/12">
            <Box className="flex items-center gap-4">
              {hasAccount && (
                <Box sx={{ zIndex: 2, position: "relative" }}>
                  <AvatarIcon avatar={avatar} width="42px" height="42px" />
                </Box>
              )}
              <Box className="flex column">
                <Typography
                  component="span"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "var(--text-color)",
                  }}>
                  {username}
                </Typography>
                <Typography
                  component="span"
                  sx={{ fontSize: "12px", color: "var(--grey2)" }}>
                  {moment(schedule_date).format("DD MMM, YYYY")}
                </Typography>
              </Box>
              {hasAccount && (
                <Box className="flex items-center gap-4">
                  <IconsAccounts
                    socialType={social_type}
                    width="32px"
                    height="32px"
                    style={{ borderRadius: "10%" }}
                  />
                </Box>
              )}
            </Box>
            <Box className="flex column gap-4">
              <Typography
                component="span"
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "var(--text-color)",
                }}>
                {type_data.title}
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: "14px", color: "var(--grey2)" }}>
                {type_data.text}
              </Typography>
            </Box>
          </Box>
          <Box className="flex item-center gap-4">
            {previewFileId && (
              <ImageError
                src={_request.files.formLink(previewFileId)}
                className="image"
                width="180px"
                height="180px"
                style={{ borderRadius: "10px" }}
              />
            )}
            <Box className="flex items-center text-center">
              {countFiles > 0 && (
                <Typography
                  component="span"
                  sx={{ fontSize: "20px", color: "var(--text-color)" }}>
                  +{countFiles} &nbsp;{i18n.t("draftsPage.more")}
                </Typography>
              )}
            </Box>
          </Box>
          <Box className="absolute top-0 right-0 cursor-pointer">
            <MoreHorizontalIcon
              onClick={(e) => this.handleMenuDraft(e, post.id)}
              style={{
                width: "30px",
                height: "30px",
                color: "white",
              }}
            />
          </Box>
          {this.insertMenuDraftItems()}
        </Box>
      </Box>
    );
  }

  renderTopPanel(itemsLength) {
    return (
      <Box className="flex between centerV bgDarkTheme pad10 h-[5.313rem]">
        <Box className="flex1 flex gap8 font f28 col black07">
          {" "}
          <Typography
            className="page-title"
            sx={{ padding: 5, color: "var(--text-color)" }}>
            {i18n.t("draftsPage.drafts")}
          </Typography>
        </Box>
        {itemsLength > 0 && (
          <Box className="flex gap8">
            <Box
              className="btnDark"
              onClick={(event) => {
                this.addDraftShow(event);
              }}>
              {i18n.t("draftsPage.addDraftCollection")}
            </Box>
          </Box>
        )}
      </Box>
    );
  }

  retrieveItems(draftCollections) {
    return draftCollections.map((it, i) => this.insertGroup(i, it));
  }

  handleSocialChange = (event) => {
    this.setState({ socialType: event.target.value });
  };

  handleSortChange = (event) => {
    this.setState({ sortOrder: event.target.value });
  };

  renderPage() {
    const { draftCollections, showBlock, posts, postsAccountData } = this.state;
    const socialTypes = [
      ...new Set(
        Object.values(postsAccountData)
          .flat()
          .map((acc) => acc.social_type)
      ),
    ];

    return (
      <Box
        className="flex1 flex column gap24"
        sx={{ backgroundColor: "var(--background-menu-list)" }}>
        {this.renderTopPanel(draftCollections.length)}
        <Box sx={{ padding: "25px 45px" }}>
          <Box className="flex startC centerV mb-5">
            <Typography
              component="span"
              variant="h5"
              sx={{ marginRight: 2, color: "var(--text-color)" }}>
              {i18n.t("draftsPage.draftCollections")}
            </Typography>
          </Box>
          {draftCollections.length > 0 ? (
            showBlock ? (
              <Box className="flex1 flex startC wrap gap24">
                {this.retrieveItems(draftCollections)}
              </Box>
            ) : (
              <Box className="flex1 flex column startC">
                <Box className="flex gap-48">
                  <Button
                    className="w-0 text-black"
                    onClick={() => this.setState({ showBlock: true })}>
                    <ArrowBackIosNewOutlinedIcon
                      sx={{ color: "#42C0C7", fontWeight: 600 }}
                    />
                    <Typography
                      component="span"
                      sx={{ color: "#42C0C7", fontSize: 15, fontWeight: 600 }}>
                      {i18n.t("draftsPage.back")}
                    </Typography>
                  </Button>
                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120, color: "var(--text-color)" }}>
                    <Select
                      value={this.state.socialType}
                      onChange={this.handleSocialChange}
                      label="Social Type"
                      sx={{
                        minWidth: 120,
                        backgroundColor: "var(--background)",
                        color: "var(--text-color)",
                      }}
                      className="f14 lh border-none">
                      <MenuItem value="all">
                        {i18n.t("draftsPage.all")}
                      </MenuItem>
                      {socialTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    variant="standard"
                    sx={{ minWidth: 120, color: "var(--text-color)" }}>
                    <Select
                      value={this.state.sortOrder}
                      onChange={this.handleSortChange}
                      label="Sort By"
                      sx={{ color: "var(--text-color)" }}>
                      <MenuItem value="newest">
                        {i18n.t("draftsPage.newest")}
                      </MenuItem>
                      <MenuItem value="oldest">
                        {i18n.t("draftsPage.oldest")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {this.retrieveItemsDrafts(posts, draftCollections)}
              </Box>
            )
          ) : (
            <Box className="flex column items-center justify-center w-full h-full">
              <EmptyDraft />
              <Typography
                variant="body1"
                className="font w300"
                sx={{ color: "var(--text-color)" }}>
                {i18n.t("oopsEmpty")}
              </Typography>
              <Typography
                variant="body2"
                className="font w300"
                sx={{ color: "var(--text-login)" }}>
                {i18n.t("draftsPage.noDraftCollectionYet")}
              </Typography>
              <Box
                className="btnDark mt-4"
                sx={{ borderRadius: "23px" }}
                onClick={(event) => {
                  this.addDraftShow(event);
                }}>
                {i18n.t("draftsPage.createDraftCollection")}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export default function Drafts() {
  const navigate = useNavigate();
  return <DraftsPage {...useOutletContext()} navigate={navigate} />;
}
